'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		}
	}return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	};
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _server = require('react-dom/server');

var _server2 = _interopRequireDefault(_server);

var _text = require('components/field/text');

var _text2 = _interopRequireDefault(_text);

var _exports = require('exports');

var _exports2 = _interopRequireDefault(_exports);

var _animationHelper = require('animation-helper');

var _animationHelper2 = _interopRequireDefault(_animationHelper);

var _classList = require('class-list');

var _classList2 = _interopRequireDefault(_classList);

function _interopRequireDefault(obj) {
	return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
	if (key in obj) {
		Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	} else {
		obj[key] = value;
	}return obj;
}

function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ProductItem = function (_Component) {
	_inherits(ProductItem, _Component);

	function ProductItem() {
		_classCallCheck(this, ProductItem);

		return _possibleConstructorReturn(this, (ProductItem.__proto__ || Object.getPrototypeOf(ProductItem)).apply(this, arguments));
	}

	_createClass(ProductItem, [{
		key: 'imageURL',
		value: function imageURL() {
			return '/t/width=300/height=300/matte=fff0/scale/f' + this.props.product.image_name + '/thumb.jpg';
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement('a', { href: this.link(), className: 'product-grid-item' }, _react2.default.createElement('div', { className: 'product-image', style: { backgroundImage: 'url(' + this.imageURL() + ')' } }), _react2.default.createElement('p', null, this.props.product.title));
		}
	}, {
		key: 'link',
		value: function link() {
			return this.props.product.link;
		}
	}]);

	return ProductItem;
}(_react.Component);

;

var ProductList = function (_Component2) {
	_inherits(ProductList, _Component2);

	function ProductList(props) {
		_classCallCheck(this, ProductList);

		var _this2 = _possibleConstructorReturn(this, (ProductList.__proto__ || Object.getPrototypeOf(ProductList)).call(this, props));

		_this2.state = { selectedGroup: null };

		if (!ProductList.recordsForGroups[props.group]) {
			if (_exports2.default.Channel) {
				if (/^search:/.test(props.group)) {
					var query = props.group.substring('search:'.length);
					var search = _exports2.default.Channel.tools.products.lwp('search', { query: query }).records;
					var RR = _exports2.default.Channel.tools.products.getRecords(search);
					ProductList.recordsForGroups[props.group] = search.map(function (id) {
						return RR[id];
					}).filter(function (v) {
						return !!v;
					}).map(function (record) {
						return {
							id: record.id,
							title: record.title,
							image_name: record.image_name,
							seo_url: record.seo_url,
							link: _exports2.default.Link('product-detail', record)
						};
					});
					_this2.state.selectedGroup = props.group;
				} else {
					var group = _exports2.default.Channel.tools.products.groups[props.group];
					ProductList.recordsForGroups[props.group] = [].map.call(group.records, function (record) {
						return {
							id: record.id,
							title: record.title,
							image_name: record.image_name,
							seo_url: record.seo_url,
							link: _exports2.default.Link('product-detail', { record: record, group: group })
						};
					});
					_this2.state.selectedGroup = props.group;
				}
			}
		} else {
			_this2.state.selectedGroup = props.group;
		}
		return _this2;
	}

	_createClass(ProductList, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.componentDidUpdate();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			var _this3 = this;

			if (!this.state.selectedGroup || this.state.selectedGroup != this.props.group) {
				if (ProductList.recordsForGroups[this.props.group]) {
					this.setState({ selectedGroup: this.props.group });
				} else {
					this.loadRecords().then(function (data) {
						ProductList.recordsForGroups[_this3.props.group] = data;
						_this3.setState({ selectedGroup: _this3.props.group });
					});
				}
			}
		}
	}, {
		key: 'loadRecords',
		value: function loadRecords() {
			var _this4 = this;

			return new Promise(function (resolve) {
				var xhr = new XMLHttpRequest();
				xhr.open('GET', 'data/products?group=' + _this4.props.group, true);
				xhr.onreadystatechange = function () {
					if (xhr.readyState == 4) {
						resolve(JSON.parse(xhr.responseText));
					}
				};
				xhr.send();
			});
		}
	}, {
		key: 'childGroups',
		value: function childGroups() {
			var _this5 = this;

			var X = Object.keys(this.props.groups).map(function (id) {
				return _this5.props.groups[id];
			}).filter(function (group) {
				return group.parent_group_id == _this5.props.group;
			});
			X.sort(function (left, right) {
				return left.display_order - right.display_order;
			});
			return X;
		}
	}, {
		key: 'render',
		value: function render() {
			var _this6 = this;

			var itemList = ProductList.recordsForGroups[this.props.group] || [];

			return _react2.default.createElement('section', { className: 'product-group' }, itemList.length ? _react2.default.createElement('header', null, this.props.groups[this.props.group].title) : null, itemList.length ? _react2.default.createElement('header', null, this.props.groups[this.props.group].summary) : null, itemList.length ? _react2.default.createElement('section', { className: 'product-grid' }, itemList.map(function (item) {
				return _react2.default.createElement(ProductItem, { key: item.id, product: item, group: _this6.props.group, groups: _this6.props.groups });
			})) : null, this.childGroups().map(function (group) {
				return _react2.default.createElement(ProductList, { group: group.id, groups: _this6.props.groups, key: group.id });
			}));
		}
	}]);

	return ProductList;
}(_react.Component);

ProductList.recordsForGroups = {};

var App = function (_Component3) {
	_inherits(App, _Component3);

	_createClass(App, null, [{
		key: 'filter',
		value: function filter(group) {
			return {
				id: group.id,
				parent_group_id: group.parent_group_id || null,
				display_order: Number(group.display_order),
				file_name: group.file_name,
				title: group.title,
				seo_url: group.seo_url
			};
		}
	}, {
		key: 'serverRender',
		value: function serverRender(page, productGroup, defaultProductGroup, queryData) {
			var _this8 = this;

			var groupList = {};

			var app = _exports2.default.Channel.tools.products;
			var appGroups = app.lwp('find', { $group: true, deleted: 0 }).records;
			appGroups.forEach(function (id) {
				return groupList[id] = _this8.filter(app.groups[id]);
			});

			if (queryData.q) {
				productGroup = this.getSearchGroup(queryData.q);
				groupList[productGroup.id] = productGroup;
			}

			return '\n\t\t\t<div data-component="ProductList">' + _server2.default.renderToString(_react2.default.createElement(App, { defaultGroup: defaultProductGroup.id, group: (productGroup || defaultProductGroup).id, groups: groupList })) + '</div>\n\t\t\t' + page.inlineScript('\n\t\t\t\tvar groups = ' + JSON.stringify(groupList) + ';\n\t\t\t\tvar productList = ' + JSON.stringify(ProductList.recordsForGroups) + ';\n\t\t\t\tvar productGroup = ' + JSON.stringify((productGroup || defaultProductGroup).id) + ';\n\t\t\t\tvar defaultGroup = ' + JSON.stringify(defaultProductGroup.id) + ';\n\t\t\t\trequire(\'products/app\').default.clientRender(this.querySelector(\'[data-component=ProductList]\'), productList, groups, productGroup, defaultGroup);\n\t\t\t') + '\n\t\t';
		}
	}, {
		key: 'clientRender',
		value: function clientRender(node, productList, groups, productGroup, defaultGroup) {
			ProductList.recordsForGroups = productList;
			_reactDom2.default.render(_react2.default.createElement(App, { group: productGroup, groups: groups, defaultGroup: defaultGroup }), node);
		}
	}]);

	function App(props) {
		_classCallCheck(this, App);

		var _this7 = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

		_this7.state = {
			groups: Object.assign({}, _this7.props.groups),
			selectedGroup: props.group,
			previousGroup: null
		};
		if (props.groups[props.group].isSearch) _this7.state.searchText = props.groups[props.group].searchText;

		_this7.popState = _this7.popState.bind(_this7);
		_this7.fadeOutPrevious = _this7.fadeOutPrevious.bind(_this7);
		return _this7;
	}

	_createClass(App, [{
		key: 'getSearchGroup',
		value: function getSearchGroup(query) {
			return App.getSearchGroup(query);
		}
	}, {
		key: 'createSearchGroup',
		value: function createSearchGroup(callback) {
			if (this.state.groups['search:' + this.searchQuery]) {
				callback(this.state.groups['search:' + this.searchQuery]);
				return;
			}

			var searchGroup = this.getSearchGroup(this.searchQuery);

			this.setState(function (state) {
				var T = Object.assign({}, state.groups, _defineProperty({}, searchGroup.id, searchGroup));
				return state;
			}, function () {
				return callback(searchGroup);
			});
		}
	}, {
		key: 'childGroups',
		value: function childGroups(id) {
			var _this9 = this;

			var top = Object.keys(this.state.groups).map(function (id) {
				return _this9.state.groups[id];
			}).filter(function (group) {
				return !group.isSearch && group.parent_group_id == id;
			});
			top.sort(function (left, right) {
				return Number(left.display_order) - Number(right.display_order);
			});
			return top;
		}
	}, {
		key: 'render',
		value: function render() {
			var _this10 = this;

			return _react2.default.createElement('div', null, _react2.default.createElement('div', { className: 'large-header vertical-detail',
				style: {
					backgroundImage: 'linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, .5)), \n\t\t\t\t\t\turl(' + ((this.group || {}).file_name || '/admin/platform/plugins/com.sightworks.5.Channel.instance.marketing/resources/images/tpash-bg-product2-1200x788.jpg') + ')'
				}
			}, _react2.default.createElement('div', { className: 'inner-content col-md-8' }, _react2.default.createElement('h3', { className: 'uppercase' }, 'Shop'), _react2.default.createElement('h1', { className: 'uppercase' }, this.group ? this.group.title : 'All Products'))), _react2.default.createElement('div', { className: 'email-signup-banner' }, _react2.default.createElement('p', null, _react2.default.createElement('img', { className: 'icon-email-signup', src: '/admin/platform/plugins/com.sightworks.5.Channel.instance.marketing/resources/images/icon-email-signup.png' }), 'Get seasonal buying advice and promotions in your inbox.'), _react2.default.createElement('button', { className: 'btn btn-secondary white' }, 'Sign Up')), _react2.default.createElement('div', { className: 'grey-products-banner' }, _react2.default.createElement('div', { className: 'inner-content' }, _react2.default.createElement('div', { className: 'new-flag', style: {
					backgroundImage: 'url(/admin/platform/plugins/com.sightworks.5.Channel.instance.marketing/resources/images/pink-flag.png)'
				} }, _react2.default.createElement('p', null, 'New')), _react2.default.createElement('p', null, 'Select products online and pick up at one of our convenient locations'))), _react2.default.createElement('div', { className: 'product-list-stack' }, _react2.default.createElement('nav', { className: 'product-nav' }, _react2.default.createElement('section', { className: 'product-search' }, _react2.default.createElement('header', null, 'Search'), _react2.default.createElement('div', { className: _classList2.default.join('search-box', this.searchQuery ? 'has-search' : '') }, _react2.default.createElement('input', { type: 'text', name: 'search', value: this.searchQuery, onChange: function onChange(event) {
					return _this10.setSearchQuery(event.target.value);
				} }), _react2.default.createElement('button', { className: 'submit', onClick: function onClick() {
					return _this10.createSearchGroup(function (group) {
						return _this10.selectGroup(group);
					});
				} }, _react2.default.createElement('span', { className: 'glyphicon glyphicon-search' })))), this.topGroups.map(function (group) {
				return _react2.default.createElement('section', { key: group.id }, _react2.default.createElement('header', null, group.title), _react2.default.createElement('ul', null, _this10.childGroups(group.id).map(function (node) {
					return _react2.default.createElement('li', { key: node.id, className: _this10.state.selectedGroup == node.id ? 'active' : '' }, _react2.default.createElement('a', { href: node.id == _this10.props.defaultGroup ? 'shop' : 'shop/' + group.seo_url + '/' + node.seo_url, onClick: function onClick(event) {
							event.preventDefault();_this10.selectGroup(node);
						} }, node.title));
				})));
			})), _react2.default.createElement('section', { className: 'productContent' }, this.previousDisplay ? _react2.default.createElement('section', { className: 'previousProductContent', ref: this.fadeOutPrevious }, this.previousDisplay) : null, this.display)));
		}
	}, {
		key: 'setSearchQuery',
		value: function setSearchQuery(value) {
			this.setState({ searchText: value });
		}
	}, {
		key: 'fadeOutPrevious',
		value: function fadeOutPrevious(node) {
			var _this11 = this;

			if (!node) return;

			var A = new _animationHelper2.default(300, 'ease', function (position) {
				node.style.opacity = 1 - position;
			}, function () {
				_this11.setState({ previousGroup: null });
			});
			A.start();
		}
	}, {
		key: 'selectGroup',
		value: function selectGroup(group, force) {
			if (!force && this.state.previousGroup) return;
			var addGroups = {};
			var addState = {};

			if (!this.state.groups[group.id]) {
				addGroups[group.id] = group;
				if (group.isSearch) addState.searchText = group.searchText;
			}
			this.setState(function (state) {
				return Object.assign(addState, {
					previousGroup: state.selectedGroup,
					selectedGroup: group.id,
					groups: Object.assign(addGroups, state.groups)
				});
			});
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			if (window.history) {
				if (window.history.state && window.history.state.id == this.group.id) return;

				var path = 'shop';
				var groupPath = [];
				var group = this.group;

				if (!group.isSearch && group.id != this.props.defaultGroup) {
					while (group) {
						groupPath.unshift(group.seo_url);
						group = this.state.groups[group.parent_group_id];
					}
				}

				path += '/' + groupPath.join('/');
				path = path.split('/').filter(function (v) {
					return !!v;
				}).join('/');

				var b = document.querySelector('base').href;
				if (b[b.length - 1] != '/') b += '/';
				b += path;

				if (this.group.isSearch) {
					b += '?q=' + encodeURIComponent(this.group.searchText);
				}

				history.pushState({ id: this.group.id }, this.group.title, b);
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (window.history) {
				if (window.history.state && window.history.state.id && window.history.state.id != this.state.group) {
					var tgtGroup = this.state.groups[window.history.state.id];
					if (!tgtGroup && window.history.state.id.startsWith('search:')) {
						tgtGroup = this.getSearchGroup(window.history.state.id.substring('search:'.length));
					}
					this.selectGroup(tgtGroup, true);
				}
				if (!window.history.state) {
					history.replaceState({ id: this.group.id }, this.group.title, location.href);
				}
				window.addEventListener('popstate', this.popState);
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			window.removeEventListener('popstate', this.popState);
		}
	}, {
		key: 'popState',
		value: function popState(event) {
			if (event.state) {
				if (event.state.id != this.state.group) {
					var tgtGroup = this.state.groups[event.state.id];
					if (!tgtGroup && event.state.id.startsWith('search:')) {
						tgtGroup = this.getSearchGroup(event.state.id.substring('search:'.length));
					}
					this.selectGroup(tgtGroup, true);
				}
			}
		}
	}, {
		key: 'group',
		get: function get() {
			return this.state.groups[this.state.selectedGroup];
		}
	}, {
		key: 'topGroups',
		get: function get() {
			return this.childGroups(null);
		}
	}, {
		key: 'display',
		get: function get() {
			return _react2.default.createElement(ProductList, { groups: this.state.groups, group: this.group.id });
		}
	}, {
		key: 'previousDisplay',
		get: function get() {
			if (this.state.previousGroup) return _react2.default.createElement(ProductList, { groups: this.state.groups, group: this.state.previousGroup });
			return null;
		}
	}, {
		key: 'searchQuery',
		get: function get() {
			return this.state.searchText || "";
		}
	}], [{
		key: 'getSearchGroup',
		value: function getSearchGroup(query) {
			var searchGroup = {
				id: 'search:' + query,
				parent_group_id: null,
				display_order: -1,
				isSearch: true,
				file_name: "",
				title: 'Search: ' + query,
				searchText: query,
				seo_url: ""
			};
			return searchGroup;
		}
	}]);

	return App;
}(_react.Component);

exports.default = App;